import dynamic from "next/dynamic";

export const DynamicContent020 = dynamic(() => import("./Content020"), {
  suspense: true,
});
